import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { fetchShareIdDetails } from "../../../redux/actions/lambdaTestTestDetailActions";
import { getShareId } from "../../../utility/utilityFunctions";

import { LTText } from "@lambdatestincprivate/lt-components";
import ComponentNoDataFound from "../../../components/ml2.0/ComponentNoDataFound";
import styles from "./index.module.css";
import TestDetailPageWrapper from "../TestDetailPageWrapper";

const queryString = require("query-string");

const SharedPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const sharedDataCount = useSelector(
    state => state.lambdaTestTestDetailHashMap.sharedData.total
  );
  const sharingFailedErrorMsg = useSelector(
    state => state.lambdaTestTestDetailHashMap.sharingFailedErrorMsg
  );

  const [pageType, setPageType] = useState("");
  const parsed = queryString.parse(location.search);
  const shareId = getShareId();
  const testId = parsed.testID;
  useEffect(() => {
    dispatch(fetchShareIdDetails(shareId));
  }, []);

  useEffect(() => {
    if (sharedDataCount > 1) {
      setPageType("buildPage");
    }
    if (sharedDataCount === 1) {
      setPageType("testPage");
    }
  }, [sharedDataCount, testId]);

  const renderSharingHeader = () => {
    return (
      <div className={`${styles.testDetailTopBar}`}>
        <div className={styles.brandLogo}>
          <a href="https://www.lambdatest.com/">
            <img
              src="https://assets.testmu.ai/resources/images/logos/logo.svg"
              alt="Logo"
              height="26"
            />
          </a>
        </div>
        <div className={styles.separator}></div>
        <LTText variant={LTText.TextVariant.HEADER_BOLD} color="#333">
          Automation
        </LTText>
      </div>
    );
  };

  if (sharingFailedErrorMsg || sharedDataCount === 0) {
    return (
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        {renderSharingHeader()}
        <ComponentNoDataFound
          message={sharingFailedErrorMsg || "Test not found"}
        />
        ;
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {renderSharingHeader()}
      <TestDetailPageWrapper pageType={pageType} />
    </div>
  );
};

export default SharedPage;
